/**
 * @file Textarea input type - extends String with textarea edit component
 * @version 1.0.0
 */

import { StringInputType } from './string.js';

export const TextareaInputType = {
  name: 'textarea',
  matches: getAttribute => {
    return (
      getAttribute('format') === 'textarea' ||
      (getAttribute('maxLength') && getAttribute('maxLength') > 255)
    );
  },
  displayComponent: {
    name: 'TextareaEdit',
    extends: StringInputType.displayComponent,
    template: `<pre>{{ formattedValue }}</pre>`,
  },
  editComponent: {
    name: 'TextareaEdit',
    extends: StringInputType.editComponent,
    template: `
      <textarea
        class="form-control form-control-sm"
        :class="{ 'is-invalid': validationError }"
        :value="value || ''"
        v-bind="inputAttributes"
        style="min-width: 150px"
        :style="getAttribute('inputStyle')"
        @input="handleInput"
        @keydown="$emit('keydown', $event)"
        @blur="$emit('blur', $event)"
      ></textarea>
    `,
  },
};

export default TextareaInputType;
